import { StandardConfig } from "util/stdconfig";
import { Feature } from "util/stdtypes";

export const OpenLinksInNewTabFeature: Feature<StandardConfig, {}> = {
    key: 'openlinksinnewtab',
    name: 'Open Links in New Tab',
    dev: true,
    providesConfig: {
        openLinksInNewTab: true
    }
}
